import React, { useState } from "react";
import axios from "axios";
import { Link,useNavigate } from "react-router-dom";
import LoadJscript from "../components/LoadJscript";
import Newsletter from "../components/Newsletter";
import API_URLS from "../config/apiConfig";
import swal from 'sweetalert';
import { ClipLoader } from "react-spinners";
const Login = ({setIsLoggedIn}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",   
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" }); // Clear errors on input change
  };

  // Validate form inputs
  const validate = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = "Please enter your email";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter valid email";
    }
   
    if (!formData.password.trim()){ newErrors.password = "Please enter password";}
    
    
    return newErrors;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(API_URLS.LOGIN, formData);
      if(response.data.success==1){
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("tutor", JSON.stringify(response.data.tutor));
        setIsLoggedIn(true);
        navigate("/manager/dashboard"); // Redirect to the target page
    
     
      }else{
      swal("Error", response.data.message, "error");  
      }
      
      console.log(response.data); // Handle response
    } catch (error) {
      swal("Error", "Login failed. Please try again.", "error");  
      console.error("Error:", error.response?.data || error.message);
    }finally {
      setLoading(false); 
    }
  };
    return (
      <main>
         {loading && (
                        <div className="loader-overlay">
                            <ClipLoader color="#08A9E6" loading={loading} size={50} />
                        </div>
                    )}
         <div className="inner-banner inner-banner-bg2">
            <div className="container">
                <div className="inner-title text-center">
                    <h3>Sign in</h3>
                    <ul>
                        <li>
                        <Link to="/">Home</Link>
                        </li>
                        <li>Sign in</li>
                    </ul>
                </div>
            </div>
        </div>
       
        <div className="user-area pt-100 pb-70">
            <div className="container">
                <div className="row align-items-center justify-content-center">
                    <div className="col-lg-6">
                        <div className="user-img">
                            <img src="assets/images/faq-img.jpg" alt="faq" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="user-all-form">
                            <div className="contact-form">
                                <h3 className="user-title"> Sign in</h3>
                                <form id="loginForm" onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-lg-12 ">
                                            <div className="form-group">
                                                <input type="text" name="email" id="email" className="form-control"  data-error="Email Address*" placeholder="Email Address*" value={formData.email} onChange={handleChange}/>
                                                {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group">
                                                <input className="form-control" type="password" name="password" placeholder="Password*" value={formData.password} onChange={handleChange}/>
                                                {errors.password && <p style={{ color: "red" }}>{errors.password}</p>}
                                            </div>
                                        </div>

                                        <div className="col-lg-12 form-condition">
                                            <div className="agree-label">
                                                <input type="checkbox" id="chb1" />
                                                <label htmlFor="chb1">
                                                    Remember Me <a className="forget" href="forgot-password.html">Forgot Password?</a>
                                                </label>
                                            </div>
                                        </div>
        
                                        <div className="col-lg-12 col-md-12">
                                            <button type="submit" className="default-btn">
                                            {loading ? "Submitting..." : "Login Now"}
                                            </button>
                                           
                                            <Link to="/signup" className="float-end ms-2">Signup Now</Link>
                                            <label className="float-end">Don't have account?</label> 
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        <Newsletter/>
        <LoadJscript/>
      </main>
    );
  }
  
  export default Login;  